// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageWrapper_wrapper__jwmyK"};